<template>
    <div class="table-header">
        <span class="table-header__column" data-column="title" v-text="'Title'"/>
        <span class="table-header__column" data-column="category" v-text="'Category'"/>
        <span class="table-header__column" data-column="sector" v-text="'Main Sector'"/>
        <button
            class="table-header__column"
            data-column="created"
            @click.prevent.stop="changeSort"
        >
            <span v-text="'Created'"/>
            <svg
                v-if="sort && (sort === 'asc' || sort === 'desc')"
                :class="{
                    'svg-icon': true,
                    'sort-icon': true,
                    'sort': true,
                    'sort--asc' : this.sort && this.sort === 'asc',
                    'sort--desc' : this.sort && this.sort === 'desc',
                }"
            >
                <use xlink:href="#icon--sort"></use>
            </svg>
        </button>
    </div>
</template>
<script>
import debounce from 'debounce';

export default {
    name: 'DocumentsTableHeader',
    data: () => ({
        sort: null,
    }),
    methods: {
        changeSort() {
            switch(this.sort) {
                case 'asc':
                    this.sort = null;
                    break;
                case 'desc':
                    this.sort = 'asc';
                    break;
                default:
                    this.sort = 'desc';
                    break;
            }
        },
    },
    watch: {
        sort: {
            handler: debounce(function() {
                this.$emit('changeSort', this.sort);
            }, 650), // 500ms delay
            immediate: false
        }
    },
}
</script>
<style lang="scss" scoped>
@import '~@/theme/_variables.scss';

.table-header {
    .table-header__column {
        &[data-column="title"] {
            flex: 1 1 auto;
            max-width: calc(((100% - 20rem) - 24rem) - 10.2rem);
        }

        &[data-column="category"] {
            flex: 0 0 20rem;
        }

        &[data-column="sector"] {
            flex: 0 0 24rem;
        }

        &[data-column="created"] {
            flex: 0 0 10rem;
            text-align: right;
            justify-content: flex-end;
        }
    }

    @media screen and (max-width: 991px) {
        display: none !important;
    }
}
</style>
